import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from '../../universal-nav/hooks/useUniversalNavContext';
const formatAccountsPlanData = (accountsPlanData) => {
    return {
        interval: accountsPlanData.interval,
        planType: accountsPlanData.plan_type,
        actions: accountsPlanData.actions,
        meteredPricingTiers: accountsPlanData.metered_pricing_tiers.map(([numTasks, pricePerTask]) => ({
            numTasks,
            pricePerTask,
        })),
    };
};
export const useQueryAccountPlan = (accountId, planId) => {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['accountPlan', accountId, planId],
        queryFn: async () => {
            if (!accountId || !planId)
                throw new Error('Missing either accountId or planId');
            const response = await fetch(`${apiHostname}/api/v3/accounts/${encodeURIComponent(accountId)}/plans/${encodeURIComponent(planId)}`, {
                credentials: process.env.NODE_ENV !== 'test' ? 'include' : 'same-origin',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const accountsPlanJson = await response.json();
            return accountsPlanJson;
        },
        select: formatAccountsPlanData,
        enabled: !!accountId && !!planId,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
};
//# sourceMappingURL=useQueryAccountPlan.js.map
// @zapier/universal-layout@8.3.7 (9c955f548)
